// extracted by mini-css-extract-plugin
export default {"contacts_form_input":"textarea_contacts_form_input__ihF2o"};